import i18n from "i18n";
import UserNotification from "util/UserNotification";
const executeDuplicationHandler = async (view, isPermitted, duplicationHandlers) => {
  let updatedView = view.toBuilder().build();
  for (const duplicationHandler of duplicationHandlers) {
    const viewWithPluginData = await duplicationHandler(updatedView, isPermitted).catch((e) => {
      console.error(`An error occurred when executing a submit handler from a plugin: ${e}`);
      UserNotification.error(i18n.t("save_view_notifications.plugin_submit_failed", { ns: "search", error: e }));
      return updatedView;
    });
    if (viewWithPluginData) {
      updatedView = viewWithPluginData;
    }
  }
  return updatedView;
};
export const executePluggableSearchDuplicationHandler = (view, isPermitted, pluggableSaveViewControls) => {
  const pluginDuplicationHandlers = pluggableSaveViewControls == null ? void 0 : pluggableSaveViewControls.map(({ onSearchDuplication }) => onSearchDuplication).filter((pluginData) => !!pluginData);
  return executeDuplicationHandler(view, isPermitted, pluginDuplicationHandlers);
};
export const executePluggableDashboardDuplicationHandler = (view, isPermitted, pluggableSaveViewControls) => {
  const pluginDuplicationHandlers = pluggableSaveViewControls == null ? void 0 : pluggableSaveViewControls.map(({ onDashboardDuplication }) => onDashboardDuplication).filter((pluginData) => !!pluginData);
  return executeDuplicationHandler(view, isPermitted, pluginDuplicationHandlers);
};
